export const Slice = 'SLICE';
export const Piece = 'PIECE';
export const Layout = 'LAYOUT';
export const Composition = 'COMPOSITION';

// eslint-disable-next-line @typescript-eslint/no-shadow
export enum IdtComponentRole { Slice, Piece, Layout, Composition }
